import React from 'react';
import { useTranslation } from 'react-i18next';

const iconCls = "w-7 h-7 text-white";
const stroke = { fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };

const STEPS = [
  {
    key: 'step1',
    color: 'from-purple-500 to-fuchsia-500',
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><path d="M12 5v14M5 12h14" /></svg>),
  },
  {
    key: 'step2',
    color: 'from-pink-500 to-rose-500',
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><path d="M12 16V4m0 0l-4 4m4-4l4 4" /><path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" /></svg>),
  },
  {
    key: 'step3',
    color: 'from-blue-500 to-cyan-500',
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><path d="M8 5v14l11-7z" /></svg>),
  },
  {
    key: 'step4',
    color: 'from-emerald-500 to-teal-500',
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4" /></svg>),
  },
];

export default function HowItWorksSection() {
  const { t } = useTranslation();

  return (
    <section id="how-it-works" className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">{t('howItWorks.title')}</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">{t('howItWorks.subtitle')}</p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, index) => (
            <div key={step.key} className="relative bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-lg transition">
              <span className="absolute top-4 end-5 text-5xl font-extrabold text-gray-100 select-none">
                {index + 1}
              </span>
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${step.color} flex items-center justify-center mb-4 shadow-md`}>
                {step.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1.5">{t(`howItWorks.${step.key}.title`)}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{t(`howItWorks.${step.key}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
